/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { gql, useMutation } from '@apollo/client';

export const useSellCheckout = () => {

  const SELL_CHECKOUT_GQL = gql`
    mutation SellCheckout($sellCheckoutRequest: SellCheckoutRequest!) {
  sellCheckout(sellCheckoutRequest: $sellCheckoutRequest) {
    pooledSellCheckOutRes {
      orderId
      orderStatus
      pooledSellCheckOutRes
    }
  }
}`;
  const SELL_PAYMENT_GQL = gql`
  mutation CreateSellPaymentInstruction($createSellPaymentInstructionRequest: CreateSellPaymentInstructionRequest!) {
  createSellPaymentInstruction(createSellPaymentInstructionRequest: $createSellPaymentInstructionRequest) {
    orderId
    piId
  }
}`;

  const GQL_UPDATE_CUSTOMER_IP = gql`mutation UpdateCustomerIP($input: CartCustomerMetrics!) {
  updateCustomerIP(input: $input) {
    orderId
  }
}`;

  const [sellAddPaymentInstructions] = useMutation(SELL_PAYMENT_GQL,{ context:{
            clientName:"/secure-storage/checkout"
        }})
  const [sellCheckout] = useMutation(SELL_CHECKOUT_GQL,{
     context:{
            clientName:"/secure-storage/manage"
        }
  });
  const [gqlUpdateCustomerIP] = useMutation(GQL_UPDATE_CUSTOMER_IP,
    { context:{
            clientName:"/secure-storage/manage"
        }}
  );

  return {
    sellCheckout: async ({ sellCheckoutRequest }) => {
      return sellCheckout({ variables: { sellCheckoutRequest } });
    },
    sellAddPaymentInstructions: ({ createSellPaymentInstructionRequest }) => {
      return sellAddPaymentInstructions({ variables: { createSellPaymentInstructionRequest } })
    },
    updateCustomerIP: async () => {
      let customerIP;
      await fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => {
          customerIP = data.ip;
        })
        .catch(error => {
          console.log('Error:', error);
        });

      const variablesCustIp: any = {
        "ip": customerIP ? customerIP.toString() : "0.0.0.0",
        "userAgent": navigator?.userAgent,
        "accept": "*/*",
        "browserLanguage": navigator?.language,
        "timeZone": new Date().getTimezoneOffset().toString(),
        "javaEnabled": navigator?.javaEnabled(),
        "javascriptEnabled": true,
        "colorDepth": screen.colorDepth,
        "screenHeight": screen.height,
        "screenWidth": screen.width
      }

      gqlUpdateCustomerIP({
        variables: {
          input: variablesCustIp
        }
      });
    }
  }
}